import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, listenForInstallPrompt } from "@/lib/pwa";
import { bootstrapNativeApp } from "@/lib/native";
import { enableCardTables } from "@/lib/cardTables";

bootstrapNativeApp();
enableCardTables();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Boot the PWA layer — no-op when not supported.
listenForInstallPrompt();
registerServiceWorker();
